// extracted by css-extract-rspack-plugin
export default {"container":"_45c4408a","textContainer":"_8ce48477","text":"_7eea2d0","readMore":"_eb1f65aa"};